
<template>
  <div id="app">
    <div class="app-name-div">
      <img src="../../assets/img/app-info-name@2x.png" alt />
      <div class="app-ba-content">VIP的强大功能</div>
    </div>

    <div class="app-info-s">
      <div class="app-info-logo">
        <img src="../../assets/img/vip-mwz@2x.png" alt />
      </div>
      <div class="app-info-content">
        <span class="app-name">秒伪装</span>
        <br />
        <span class="app-desc">紧急情况，翻转手机、背面朝上秒回伪装界面，保护秘密，一切尽在不言中！</span>
      </div>
      <div class="app-info-right">VIP专享</div>
    </div>

    <div class="app-info-s">
      <div class="app-info-logo">
        <img src="../../assets/img/vip-news@2x.png" alt />
      </div>
      <div class="app-info-content">
        <span class="app-name">消息提醒智能伪装</span>
        <br />
        <span class="app-desc">新消息的提示智能设置伪装，光明正大地提醒有新消息，除了你没人能知道真相！</span>
      </div>
      <div class="app-info-right">VIP专享</div>
    </div>

    <div class="app-info-s">
      <div class="app-info-logo">
        <img src="../../assets/img/vip-liantian@2x.png" alt />
      </div>
      <div class="app-info-content">
        <span class="app-name">换手机不丢聊天记录</span>
        <br />
        <span class="app-desc">云端保存2年记录，换手机、卸APP都不怕！急情况时，一键永久删，无后顾之忧！</span>
      </div>
      <div class="app-info-right">VIP专享</div>
    </div>

    <div class="app-name-div">
      <img src="../../assets/img/app-info-name@2x.png" alt />
      <div class="app-ba-content">VIP可选伪装APP</div>
    </div>

    <div class="vip-app-list">
      <div class="vip-app-s">
        <img src="../../assets/img/app-zhixuan@2x.png" alt />
        <br />
        <span>资讯APP</span>
      </div>
      <div class="vip-app-s vip-app-s-div-margin">
        <img src="../../assets/img/app-game@2x.png" alt />
        <br />
        <span>游戏APP</span>
      </div>
      <div class="vip-app-s vip-app-s-div-margin">
        <img src="../../assets/img/app-abc@2x.png" alt />
        <br />

        <span>背单词APP</span>
      </div>
      <div class="vip-app-s vip-app-s-div-margin">
        <img src="../../assets/img/app-more@2x.png" alt />
        <br />
        <span>更新中</span>
      </div>
    </div>
    <div class="app-list-desc">非VIP仅支持使用“智能计算器”</div>
  </div>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      msg: "注册协议"
    };
  }
};
</script>
<style  scoped>
.app-name-div {
  width: 344px;
  height: 44px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(245, 195, 167, 1);
  line-height: 40px;
  margin: 62px auto 60px auto;
}

.app-name-div img {
  width: 100%;
  height: 1;
}

.app-ba-content {
  position: relative;
  top: -38px;
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(245, 195, 167, 1);
  line-height: 44px;
}

.app-info-s {
  width: 632px;
  height: 122px;
  display: flex;
  margin: 0px auto 64px auto;
}

.app-info-logo {
  width: 122px;
  height: 122px;
}

.app-info-logo img {
  width: 122px;
  height: 122px;
}

.app-info-content {
  flex: 1;
  text-align: left;
  padding: 0px 0px 0px 36px;
}

.app-name {
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #e8beb7;
  line-height: 50px;
}

.app-desc {
  width: 474px;
  height: 115px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #7c768e;
  line-height: 40px;
}

.app-info-right {
  width: 108px;
  height: 30px;
  background: url("../../assets/img/app-info-right@2x.png") no-repeat;
  background-size: 100% 100%;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(127, 86, 47, 1);
  line-height: 30px;
  position: absolute;
  right: 68px;
}

.vip-app-list {
  width: 562px;
  height: 110px;
  margin: 0 auto;
}

.vip-app-list div {
  width: 110px;
  height: 110px;
  float: left;
}
.vip-app-s-div-margin {
  margin-left: 40px;
}

.vip-app-list div img {
  width: 76px;
  height: 76px;
}
.vip-app-list div span {
  width: 94px;
  height: 34px;
  font-size: 22px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #7c768e;
  line-height: 34px;
}
.app-list-desc {
  width: 100%;
  height: 40px;
  font-size: 28px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #b59991;
  line-height: 40px;
  margin: 50px auto 42px auto;
}
</style>

 


// WEBPACK FOOTER //
// src/components/common/vipContent.vue